import { isPlantScanContent, parseAgentMessage } from "../utils/agentMessageFormat";

function InlineParts({ parts }) {
  return (
    <>
      {parts.map((part, i) =>
        part.type === "bold" ? (
          <strong key={i}>{part.value}</strong>
        ) : (
          <span key={i}>{part.value}</span>
        )
      )}
    </>
  );
}

function AgentMessageContent({ content, variant = "default" }) {
  const { blocks, disclaimer } = parseAgentMessage(content);
  const isScan = variant === "crop_vision" || isPlantScanContent(content);
  const plantBlock = blocks.find((b) => b.type === "section" && /^plant$/i.test(b.title));

  return (
    <div className={`agent-msg ${isScan ? "agent-msg--scan" : ""} ${variant === "plant_followup" ? "agent-msg--followup" : ""}`}>
      {isScan ? (
        <div className="agent-msg-badge" aria-hidden="true">
          Plant scan
        </div>
      ) : null}
      {variant === "plant_followup" ? (
        <div className="agent-msg-badge agent-msg-badge--followup" aria-hidden="true">
          Plant care
        </div>
      ) : null}

      {plantBlock ? (
        <div className="agent-msg-plant-name">
          {plantBlock.paragraphs[0] ? <InlineParts parts={plantBlock.paragraphs[0]} /> : plantBlock.title}
          {plantBlock.listItems.length === 0 && plantBlock.paragraphs.length > 1
            ? plantBlock.paragraphs.slice(1).map((p, i) => (
                <p key={i} className="agent-msg-line">
                  <InlineParts parts={p} />
                </p>
              ))
            : null}
        </div>
      ) : null}

      {blocks.map((block, index) => {
        if (block.type === "section" && /^plant$/i.test(block.title)) return null;

        if (block.type === "section") {
          return (
            <section key={index} className="agent-msg-section">
              <h4 className="agent-msg-section-title">{block.title}</h4>
              {block.paragraphs.map((p, i) => (
                <p key={i} className="agent-msg-line">
                  <InlineParts parts={p} />
                </p>
              ))}
              {block.listItems.length ? (
                <ul className="agent-msg-list">
                  {block.listItems.map((item, i) => (
                    <li key={i}>
                      <InlineParts parts={item} />
                    </li>
                  ))}
                </ul>
              ) : null}
            </section>
          );
        }

        return (
          <div key={index} className="agent-msg-text">
            {block.paragraphs.map((p, i) => (
              <p key={i} className="agent-msg-line">
                <InlineParts parts={p} />
              </p>
            ))}
            {block.listItems.length ? (
              <ul className="agent-msg-list">
                {block.listItems.map((item, i) => (
                  <li key={i}>
                    <InlineParts parts={item} />
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        );
      })}

      {disclaimer ? <p className="agent-msg-disclaimer">{disclaimer}</p> : null}
    </div>
  );
}

export default AgentMessageContent;
